import { cx } from 'linaria';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import Styles from './TextLabel.module.scss';

export const TextLabelType = {
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  text: PropTypes.string,
  color: PropTypes.string,
};

const TextLabel = ({ config }) => {
  const customStyles = {
    backgroundColor: config.backgroundColor,
    borderColor: config.borderColor,
    color: config.color,
  };
  return (
    <span
      className={cx(Styles.textLabel, Styles.commonStyleLabelPrice)}
      style={customStyles}
      // role="presentation"
      // onClick={(e) => {
      //   e.stopPropagation();
      //   window.location.href = config.redirectUrl;
      // }}
    >
      {config.text}
    </span>
  );
};

TextLabel.propTypes = {
  config: PropTypes.shape(TextLabelType).isRequired,
};

const TextLabelContainer = ({ configs, customStyles }) => {
  return (
    <div className={Styles.textLabelContainer} style={customStyles}>
      {configs.map((config) => (
        <TextLabel config={config} />
      ))}
    </div>
  );
};

TextLabelContainer.defaultProps = {
  customStyles: {},
};
TextLabelContainer.propTypes = {
  configs: PropTypes.arrayOf(PropTypes.shape(TextLabelType)).isRequired,
  customStyles: PropTypes.shape({}),
};

export default memo(TextLabelContainer);